<template>
  <CreditCard
    :image-url="imageUrl"
    :name="name"
    :class="'credit-card--' + name"
  />
</template>
<script>
import CreditCard from './CreditCard'
import image from '../../../../../images/icons/credit_cards/mastercard.png'
export default {
  components: { CreditCard },
  data() {
    return {
      name: 'mastercard',
      imageUrl: ''
    }
  },
  mounted() {
    this.imageUrl = image
  }
}
</script>
